module.exports = __webpack_public_path__ + "static/media/cashback.d4384e89.png";